import { AgentRegistry } from "../AgentRegistry";
import { AgentRegistryLabelPrinterModule } from "../AgentRegistryLabelPrinterModule";
import { environment } from "../enviroment";
import { AuthenticationService } from "./AuthenticationService";

export class EGZOTechAgentService {
    private _registry: AgentRegistry | null = null;
    private _labelPrinter: AgentRegistryLabelPrinterModule | null = null;

    get registry() {
        if (!this._registry) {
            throw new Error("Registry not connected");
        }

        return this._registry;
    }

    get labelPrinter() {
        if (!this._labelPrinter) {
            throw new Error("Registry not connected");
        }

        return this._labelPrinter;
    }

    get isConnected() {
        if (!this._registry) {
            return false;
        }

        return this._registry.isReady();
    }

    constructor(
        private authenticationService: AuthenticationService
    ) {

    }

    async getAgentList(): Promise<string[]> {
        const response = await this.registry.request({
            ask: "agents"
        });

        if (response.ok && response.info === "payload: application/json") {
            return JSON.parse(response.getPayload()) as string[];
        }

        return [];
    }

    async connectToRegistry() {
        if (this._registry) {
            this._registry.close();
        }

        this._registry = new AgentRegistry("wss://agents.internal.egzotech.com/", this.authenticationService.generateJWTToken, () => "production-" + Math.floor(Math.random() * 1000000));
        // this._registry = new AgentRegistry(environment === "development" ? "ws://localhost:4080/" : "wss://agents.internal.egzotech.com/", this.authenticationService.generateJWTToken, () => "production-" + Math.floor(Math.random() * 1000000));

        await this._registry.waitUntilReady();

        this._labelPrinter = new AgentRegistryLabelPrinterModule(this._registry);
    }
}
